/**
 * 游戏推广链接配置
 * 每个游戏都有对应的推广链接地址
 */

export interface GameLink {
  name: string;
  url: string;
  shareText: string;
}

export const GAME_LINKS: Record<string, GameLink> = {
  // 五子棋
  gomoku: {
    name: '五子棋',
    url: 'https://oho.cn/gomoku',
    shareText: '来玩五子棋！经典策略游戏，黑白对弈，谁先连成五子谁获胜！'
  },

  // 国际跳棋
  checkers: {
    name: '国际跳棋',
    url: 'https://oho.cn/checkers',
    shareText: '来玩国际跳棋！经典棋类游戏，策略与智慧的较量！'
  },

  // 黑白棋（奥赛罗）
  reversi: {
    name: '黑白棋',
    url: 'https://oho.cn/reversi',
    shareText: '来玩黑白棋！翻转游戏，策略布局，占领更多棋盘！'
  },

  // 四子棋
  connectfour: {
    name: '四子棋',
    url: 'https://oho.cn/connectfour',
    shareText: '来玩四子棋！垂直连珠，先连成四子获胜！'
  },

  // 中国象棋
  xiangqi: {
    name: '中国象棋',
    url: 'https://oho.cn/xiangqi',
    shareText: '来玩中国象棋！楚河汉界，运筹帷幄，将帅之争！'
  },

  // 井字棋
  tictactoe: {
    name: '井字棋',
    url: 'https://oho.cn/tictactoe',
    shareText: '来玩井字棋！简单有趣，三子连线，快速对战！'
  },

  // 斗兽棋
  jungle: {
    name: '斗兽棋',
    url: 'https://oho.cn/jungle',
    shareText: '来玩斗兽棋！动物大战，强弱相克，策略对决！'
  },

  // 虎鸡虫棒棋
  tigerchicken: {
    name: '虎鸡虫棒棋',
    url: 'https://oho.cn/tigerchicken',
    shareText: '来玩虎鸡虫棒棋！传统民间游戏，虎吃鸡、鸡啄虫、虫蛀棒、棒打虎！'
  },

  // 直棋
  straight: {
    name: '直棋',
    url: 'https://oho.cn/straight',
    shareText: '传统直棋游戏，3个同心正方形+4条对角线形成24个交叉点。'
  },

  // 维京板棋
  hnefatafl: {
    name: '维京板棋',
    url: 'https://oho.cn/hnefatafl',
    shareText: '维京时代的经典非对称对抗棋类游戏。'
  },

  // 萨米板棋
  tablut: {
    name: '萨米板棋',
    url: 'https://oho.cn/tablut',
    shareText: '北欧萨米地区的传统板棋游戏，类似维京板棋但规则更简化。'
  },

  // 经典宝石消消看
  classic: {
    name: '经典宝石消消看',
    url: 'https://oho.cn/match3-classic',
    shareText: '来玩经典宝石消消看！匹配消除，轻松有趣！'
  },

  // 星星消消看
  stars: {
    name: '星星消消看',
    url: 'https://oho.cn/match3-stars',
    shareText: '来玩星星消消看！收集星星，闪耀消除！'
  },

  // 开心消消乐
  happy: {
    name: '开心消消乐',
    url: 'https://oho.cn/match3-happy',
    shareText: '来玩开心消消乐！开心消除，快乐游戏！'
  },

  // 水果消消乐
  fruit: {
    name: '水果消消乐',
    url: 'https://oho.cn/match3-fruit',
    shareText: '来玩水果消消乐！可爱水果，轻松消除，休闲益智！'
  }
};

/**
 * 获取游戏链接
 * @param gameType 游戏类型
 * @returns 游戏链接信息
 */
export const getGameLink = (gameType: string): GameLink | null => {
  // 处理消消看游戏的不同模式
  if (gameType === 'match3') {
    return GAME_LINKS.classic; // 默认返回经典模式
  }

  return GAME_LINKS[gameType] || null;
};

/**
 * 分享游戏链接
 * @param gameType 游戏类型
 * @returns 分享的URL
 */
export const shareGame = (gameType: string): string => {
  const gameLink = getGameLink(gameType);
  return gameLink ? gameLink.url : window.location.href;
};

/**
 * 复制游戏链接到剪贴板
 * @param gameType 游戏类型
 * @returns Promise<boolean> 是否复制成功
 */
export const copyGameLink = async (gameType: string): Promise<boolean> => {
  const url = shareGame(gameType);
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch (err) {
    // 降级方案：使用传统的复制方法
    const textArea = document.createElement('textarea');
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackErr) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};

export default GAME_LINKS;